import { render } from "./ReservaEspacios.vue?vue&type=template&id=58e1e7f0"
import script from "./ReservaEspacios.vue?vue&type=script&lang=js"
export * from "./ReservaEspacios.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__